import { Stack, Typography } from "@mui/material";

import PdfViewer from "./PdfViewer";
import TiffViewer from "./TiffViewer";

interface DocumentViewerProps {
  arquivo: string;
  mimeType: string;
  width?: string;
  height?: string;
}

function DocumentViewer({ arquivo, mimeType, width = "98%", height = "800px" }: DocumentViewerProps) {
  const tipo = mimeType?.toLowerCase() ?? "";

  if (tipo.includes("tiff") || tipo.includes("tif")) {
    return <TiffViewer arquivo={arquivo} width={width} height={height} />;
  }

  if (tipo.includes("pdf")) {
    return <PdfViewer arquivo={arquivo} width={width} height={height} />;
  }

  return (
    <Stack alignItems="center" spacing={2} sx={{ mt: 4 }}>
      <Typography>Tipo de arquivo não suportado ({mimeType || "desconhecido"}).</Typography>
    </Stack>
  );
}

export default DocumentViewer;
